import React from 'react';
import {Tbody} from '@tempo/core';
import type {SubLabel} from '@deezer/next/features/ClaimAccess/types';
import LabelTableRow from './LabelTableRow';
import Row from '@components/Table/rows/Row';
import Td from '@components/Table/core/Td';

type ArtistTableBodyProps = {
	data: SubLabel[];
	onLabelEdit: (label: SubLabel) => void;
	onLabelRemove: (label: SubLabel) => void;
};

const LabelTableBody = ({
	data,
	onLabelEdit,
	onLabelRemove,
}: ArtistTableBodyProps) => {
	if (data.length === 0) {
		return (
			<Tbody>
				<Row index={0}>
					<Td height="20px" />
				</Row>
			</Tbody>
		);
	}

	return (
		<Tbody>
			{data.map((label, rowIndex) => (
				<LabelTableRow
					key={rowIndex}
					rowIndex={rowIndex}
					label={label}
					onLabelEdit={onLabelEdit}
					onLabelRemove={onLabelRemove}
				/>
			))}
		</Tbody>
	);
};

export default LabelTableBody;
